import { render, staticRenderFns } from "./fission-campagin-edit.vue?vue&type=template&id=42977228&scoped=true&xmlns%3Ael-radio-button=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./fission-campagin-edit.vue?vue&type=script&lang=ts"
export * from "./fission-campagin-edit.vue?vue&type=script&lang=ts"
import style0 from "./fission-campagin-edit.vue?vue&type=style&index=0&id=42977228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42977228",
  null
  
)

export default component.exports